/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'
// import UIKit from 'uikit'
import settings from 'settings'

import GenericModal from 'app/views/components/Modals/GenericModal'
import Icon from 'app/views/components/Icon'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

import { fetchAssessments, createAssessmentFromWizard } from 'app/state/modules/assessments'


import Loader from 'app/views/components/Loader'
import TimeSelector from './TimeSelector'


class AssessmentWizard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      teams: false,
      time: null,
      language: null,
      teamsList: [{
        name: '',
        language: '',
      }],
    }
    this.languages = {
      golang: 'go',
      java: 'java',
      php: 'php',
      python: 'python',
      ruby: 'ruby',
      csharp: 'csharp',
      javascript: 'javascript',
    }
    this.timeRef = React.createRef()
    this.props.fetchAssessments(this.props.match.params.organization_uuid)
  }

  componentDidMount() {
    this.modal.show()
  }

  onChangeTeamValue() {

  }

  renderWizardSteps() {
    switch (this.state.step) {
      default:
        return null
    }
  }


  renderTeams() {
    return this.state.teamsList.map((team, index) => {
      const n = index
      return (
        <React.Fragment key={`team-${n}`}>
          <div className="uk-width-1-2@s uk-margin-small-top uk-inline">
            {index > 0 && (
              <Icon
                as="a"
                style={{ cursor: 'pointer' }}
                role="button"
                className="uk-form-icon uk-form-icon-flip"
                onClick={() => {
                  const { teamsList } = this.state
                  this.setState({
                    teamsList: teamsList.filter((item, i) => i !== index),
                  })
                }}
                name="delete-bin"
              />
            )}
            <input
              className="uk-input"
              type="text"
              placeholder="Team Name"
              value={team.name}
              onChange={(e) => {
                const { teamsList } = this.state
                teamsList[index].name = e.target.value
                this.setState({ teamsList })
              }}
            />
          </div>
          <div className="uk-width-1-2@s uk-margin-small-top">
            <select
              className="uk-select"
              value={team.language}
              onChange={(e) => {
                const { teamsList } = this.state
                teamsList[index].language = e.target.value
                this.setState({ teamsList })
              }}
            >
              <option hidden value="">Pick a language</option>
              {Object.keys(this.languages).sort().map((opt) => (
                <option value={opt} key={opt}>
                  {settings.engines[opt]}
                </option>
              ))}
            </select>
          </div>
        </React.Fragment>
      )
    })
  }

  renderStep3() {
    // style={{ maxHeight: window.innerHeight * 0.5, overflowY: 'auto' }}
    if (this.state.teams) {
      return (
        <div className="uk-width-1-1 uk-text-center">
          <h4 className="uk-margin-top">Create Teams and Select Languages</h4>
          <div className="uk-width-1-1 uk-margin-large-top" uk-grid="">
            {this.renderTeams()}
          </div>
          <div className="uk-flex uk-flex-center uk-margin">
            <button
              className="uk-button uk-button-primary uk-button-small uk-flex uk-flex-middle"
              type="button"
              onClick={() => {
                const { teamsList } = this.state
                this.setState({
                  teamsList: [
                    ...teamsList, {
                      name: '',
                      language: '',
                    },
                  ],
                })
              }}
            >
              Add
            <Icon name="add-circle" className="uk-margin-small-left" fill ratio={0.85} />
            </button>
          </div>
        </div>
      )
    }
    return (
      <div>
        <h4 className="uk-margin-top">What programming language should be used for the assessment?</h4>
        <div className="uk-flex uk-flex-row uk-flex-wrap uk-flex-center">
          {Object.keys(this.languages).map((language) => (
            <div
              key={language}
              onClick={() => this.setState({
                language,
              })}
              className={`uk-card uk-card-body ${this.state.language === language ? 'uk-card-primary' : 'uk-card-default'} uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-card-hover`}
              style={{
                padding: 25,
                width: 120,
                height: 120,
                margin: 10,
                cursor: 'pointer',
              }}
            >
              <i
                className={`devicon-${settings.engineIcons[language]}-plain colored uk-margin-small-bottom`}
                style={{ fontSize: 38 }}
                title={language}
              />
              <p
                className="uk-margin-remove uk-text-small"
              >
                {settings.engines[language]}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {
    return (
      <OrganizationLayout
        hideLeftNavi
        {...this.props}
        active="assessments"
        style={{
          height: 'calc(100vh - 80px)',
        }}
      >
        <GenericModal
          noOverflow
          noPadding
          ref={(ref) => {
            this.modal = ref
          }}
          isFullScreen
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          noButtons
          id="modal-assessment-wizard"
          body={(
            <>
              <div className="uk-width-xlarge uk-text-center uk-margin-auto uk-flex uk-flex-middle uk-flex-column uk-flex-center uk-padding-top uk-width-1-1">
                <h2>Welcome to </h2>
                <img src="/static/images/logo-large.png" style={{ maxWidth: 300 }} alt="Logo" />
                <h3>Let's start off by creating an assessment.</h3>
                <p>
                  Once the assessment is complete, schedule a call to review
                  your results, what they mean, and how they compare to other
                  companies in your industry.
                </p>
                <h4>
                  Do you want the same program language for everyone or do you
                  want to segment users to assess in different languages?
                </h4>
                <div className="uk-flex uk-flex-row uk-margin">
                  <button
                    className="uk-button uk-button-primary uk-button-large"
                    type="button"
                    onClick={() => {
                      this.setState({
                        teams: false,
                      }, () => {
                        this.modal2.show()
                      })
                    }}
                  >
                    Same Language
                  </button>
                  <button
                    onClick={() => {
                      this.setState({
                        teams: true,
                      }, () => {
                        this.modal2.show()
                      })
                    }}
                    className="uk-button uk-button-secondary uk-button-large uk-margin-left"
                    type="button"
                  >
                    Different Languages
                  </button>
                </div>
              </div>
            </>
          )}
        />
        <GenericModal
          noOverflow
          noPadding
          ref={(ref) => {
            this.modal2 = ref
          }}
          isFullScreen
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          noButtons
          id="modal-assessment-wizard-2"
          body={(
            <>
              <div className="uk-width-xlarge uk-text-center uk-margin-auto uk-flex uk-flex-middle uk-flex-column uk-flex-center uk-padding-top uk-width-1-1">

                <img src="/static/images/logo-large.png" style={{ maxWidth: 300 }} alt="Logo" />
                <h4>How long should users have before finishing the assessment?</h4>
                <TimeSelector
                  ref={this.timeRef}
                />
                <button
                  className="uk-button uk-button-default uk-flex uk-flex-middle uk-button-large uk-margin-top"
                  type="button"
                  onClick={() => {
                    this.setState({
                      time: this.timeRef.current.getValue(),
                    }, () => {
                      this.modal3.show()
                    })
                  }}
                >
                  Continue
                  <Icon
                    className="uk-margin-left"
                    name="arrow-right"
                  />
                </button>
              </div>
            </>
          )}
        />

        <GenericModal
          noPadding
          ref={(ref) => {
            this.modal3 = ref
          }}
          isFullScreen
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          noButtons
          id="modal-assessment-wizard-3"
          body={(
            <>
              <div className="uk-width-xxlarge uk-text-center uk-margin-auto uk-flex uk-flex-middle uk-flex-column uk-flex-center uk-padding-top uk-width-1-1">

                <img src="/static/images/logo-large.png" style={{ maxWidth: 300 }} alt="Logo" />
                {/* <h4>How long should users have before finishing the assessment?</h4> */}
                {this.renderStep3()}
                <button
                  disabled={(!this.state.teams && !this.state.language) || (this.state.teams && this.state.teamsList.some((t) => t.name.trim() === '' || t.language === ''))}
                  className="uk-button uk-button-default uk-flex uk-flex-middle uk-button-large uk-margin-top"
                  type="button"
                  onClick={() => {
                    if (this.props.freeAssessments.length > 1) {
                      return this.modal4.show()
                    }
                    this.props.createAssessmentFromWizard(
                      this.props.match.params.organization_uuid,
                      this.state.teams ? JSON.stringify(this.state.teamsList) : undefined,
                      this.props.freeAssessments[0].key,
                      this.state.time,
                      this.state.language,
                    )
                    return this.modal5.show()
                  }}
                >
                  {this.props.freeAssessments.length > 1 ? 'Continue' : 'Finish'}
                  <Icon
                    className="uk-margin-left"
                    name="arrow-right"
                  />
                </button>
              </div>
            </>
          )}
        />
        <GenericModal
          noPadding
          ref={(ref) => {
            this.modal4 = ref
          }}
          isFullScreen
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          noButtons
          id="modal-assessment-wizard-4"
          body={(
            <>
              <div className="uk-width-2-3 uk-text-center uk-margin-auto uk-flex uk-flex-middle uk-flex-column uk-flex-center uk-padding-top">

                <img src="/static/images/logo-large.png" style={{ maxWidth: 300 }} alt="Logo" />
                <h4>Pick an assessment to assign to your team.</h4>
                <table className="uk-table uk-text-small uk-text-left uk-table-middle uk-table-divider">
                  <thead>
                    <tr>
                      <th style={{ width: 150 }}>App Name</th>
                      <th>Description</th>
                      <th style={{ width: 150 }} />
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.freeAssessments.map((assessment) => (
                      <tr key={assessment.key}>
                        <td>{assessment.name}</td>
                        <td>{assessment.description}</td>
                        <td>
                          <button
                            className="uk-button uk-button-small uk-button-primary"
                            type="button"
                          >
                            SELECT
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        />

        <GenericModal
          noPadding
          ref={(ref) => {
            this.modal5 = ref
          }}
          isFullScreen
          style={{
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          noButtons
          id="modal-assessment-wizard-5"
          body={(
            <>
              <div className="uk-width-2-3 uk-text-center uk-margin-auto uk-flex uk-flex-middle uk-flex-column uk-flex-center uk-padding-top">

                <img src="/static/images/logo-large.png" style={{ maxWidth: 300 }} alt="Logo" />
                <h4>Creating assessment...</h4>
                <Loader visible />
              </div>
            </>
          )}
        />
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  organizations: state.hacker.organizationsList,
  hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,

  organizationsHash: state.hacker.organizationsHash,
  freeAssessments: state.assessments.freeAssessments,
})

export default connect(mapStateToProps, {
  fetchAssessments,
  createAssessmentFromWizard,
})(AssessmentWizard)
